export default __webpack_public_path__ + "static/media/Microsoft_logo.72f0fcc7.svg";